/**
 * Switch colors to nav-blog on scroll
 *
 * @param {}
 * @return {void}
 */

const switchNavColors = () => {
  const $nav = $('.js-nav-switch-colors');
  const $container = $('.article-featured .article__image');

  if ($container.length == 0) {
    return;
  }

  const headerHeight = $('#shopify-section-menu-bar').outerHeight();
  const containerHeight = $container.outerHeight();
  const navHeight = $nav.outerHeight();
  const scrollingAfterContainer = $(window).scrollTop() > (containerHeight + headerHeight - navHeight);

  $nav.toggleClass('is-animated', scrollingAfterContainer);
}

$(window).on('load scroll resize', function() {
  if ( $('.js-nav-switch-colors').length !== 0 ) {
    switchNavColors();
  }
});
